import { render, staticRenderFns } from "./UiStringlist.vue?vue&type=template&id=48744558&scoped=true"
import script from "./UiStringlist.vue?vue&type=script&lang=js"
export * from "./UiStringlist.vue?vue&type=script&lang=js"
import style0 from "./UiStringlist.vue?vue&type=style&index=0&id=48744558&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48744558",
  null
  
)

export default component.exports